<div id="findbarMessageContainer">
  <span id="findMsg" class="toolbarLabel"></span>
</div>
